export default __webpack_public_path__ + "static/media/cocalata.d00fc9b8.jpg";